//We don't know all art status, but we know these
export enum InternalArtStates {
  OPEN = 'OPEN',
  PEND_C = 'PEND_C',
  PEND_S_ART = 'PEND_S_ART',
  PEND_S_CSR = 'PEND_S_CSR',
  PEND_S_OUT = 'PEND_S_OUT',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  REVIEW = 'REVIEW',
  REVIEW_REQUESTED = 'REVIEW_REQUESTED',
  REVIEW_IN_PROCESS = 'REVIEW_IN_PROCESS',
  REVIEW_INFO_REQUESTED = 'REVIEW_INFO_REQUESTED',
  REVIEW_READY = 'REVIEW_READY',
  REVIEW_PAID = 'REVIEW_PAID',
}

export enum ArtStates {
  ALL = 'ALL',
  READY_TO_ORDER = 'READY_TO_ORDER',
  REQUIRES_ACTION = 'REQUIRES_ACTION',
  IN_PROGRESS = 'IN_PROGRESS',
  ARCHIVED = 'ARCHIVED',
  HISTORY = 'HISTORY'
}

export const InternalArtStatesDescriptions = {
  [InternalArtStates.OPEN]: { description: "Open" },
  [InternalArtStates.PEND_C]: { description: "Waiting on Customer" },
  [InternalArtStates.PEND_S_ART]: { description: "Waiting on Art Service" },
  [InternalArtStates.PEND_S_CSR]: { description: "Waiting on Customer Service" },
  [InternalArtStates.PEND_S_OUT]: { description: "Waiting on Digitizing Service" },
  [InternalArtStates.APPROVED]: { description: "Approved" },
  [InternalArtStates.CANCELED]: { description: "Canceled" },
  [InternalArtStates.REVIEW]: { description: "Review" },
  [InternalArtStates.REVIEW_REQUESTED]: { description: "Review Requested" },
  [InternalArtStates.REVIEW_IN_PROCESS]: { description: "Review in Process" },
  [InternalArtStates.REVIEW_INFO_REQUESTED]: { description: "Review Information Requested" },
  [InternalArtStates.REVIEW_READY]: { description: "Review Ready - Order Art Proof" },
  [InternalArtStates.REVIEW_PAID]: { description: "Review Ready - Art Proof Ordered" },
};

export const ArtStatesDescriptions = {
  [ArtStates.ALL]: { description: "All" },
  [ArtStates.READY_TO_ORDER]: { description: "Ready to order" },
  [ArtStates.REQUIRES_ACTION]: { description: "Requires customer action" },
  [ArtStates.IN_PROGRESS]: { description: "In Process" },
  [ArtStates.HISTORY]: { description: "History" },
  [ArtStates.ARCHIVED]: { description: "Archived" }
};

// Review Stages
const REVIEW_STATES = new Set<InternalArtStates>([
  InternalArtStates.REVIEW_REQUESTED,
  InternalArtStates.REVIEW_IN_PROCESS,
  InternalArtStates.REVIEW_INFO_REQUESTED,
  InternalArtStates.REVIEW_READY,
  InternalArtStates.REVIEW_PAID,
]);

export function isInReviewScenario(state: InternalArtStates | undefined): boolean {
  return state !== undefined && REVIEW_STATES.has(state);
}

export type ArtworkFolder = 'originalArtwork' | 'productionArtwork' | 'productionArtworkPreview';

export function toInternalArtState(artState: ArtStates) {

  switch (artState) {
    case ArtStates.READY_TO_ORDER:
      return [InternalArtStates.APPROVED, InternalArtStates.REVIEW, InternalArtStates.REVIEW_READY]
    case ArtStates.IN_PROGRESS:
      return [InternalArtStates.OPEN,
      InternalArtStates.PEND_S_ART,
      InternalArtStates.PEND_S_CSR,
      InternalArtStates.PEND_S_OUT,
      InternalArtStates.REVIEW_REQUESTED,
      InternalArtStates.REVIEW_IN_PROCESS,
      InternalArtStates.REVIEW_PAID
      ]
    case ArtStates.REQUIRES_ACTION:
      return [InternalArtStates.PEND_C,
      InternalArtStates.REVIEW_INFO_REQUESTED,
      ]
    default: // ArtStateFilter.ALl
      return [InternalArtStates.OPEN,
      InternalArtStates.PEND_C,
      InternalArtStates.PEND_S_ART,
      InternalArtStates.PEND_S_CSR,
      InternalArtStates.PEND_S_OUT,
      InternalArtStates.APPROVED,
      InternalArtStates.REVIEW,
      InternalArtStates.CANCELED,
      InternalArtStates.REVIEW_REQUESTED,
      InternalArtStates.REVIEW_IN_PROCESS,
      InternalArtStates.REVIEW_INFO_REQUESTED,
      InternalArtStates.REVIEW_READY,
      InternalArtStates.REVIEW_PAID,
      ]
  }
}

export function toArtState(artState: InternalArtStates) {

  switch (artState) {
    case InternalArtStates.APPROVED:
    case InternalArtStates.REVIEW:
    case InternalArtStates.REVIEW_READY:
      return ArtStates.READY_TO_ORDER
    case InternalArtStates.OPEN:
    case InternalArtStates.PEND_S_ART:
    case InternalArtStates.PEND_S_CSR:
    case InternalArtStates.PEND_S_OUT:
    case InternalArtStates.REVIEW_REQUESTED:
    case InternalArtStates.REVIEW_IN_PROCESS:
    case InternalArtStates.REVIEW_PAID:
      return ArtStates.IN_PROGRESS
    case InternalArtStates.PEND_C:
    case InternalArtStates.REVIEW_INFO_REQUESTED:
      return ArtStates.REQUIRES_ACTION
    default: // ArtStateFilter.ALl
      return ArtStates.ALL
  }
}







